import { api } from '@/lib/api/client';
import type { XkStation } from '@/lib/api/types';

/**
 * Merch planner — escribe el «esperado» por merch en las asignaciones de un evento,
 * para que Plan, Track y el informe midan contra la misma cifra. Hoy es el pedido con
 * colchón (D-3, pendiente de Daniel). El servidor lo reparte entre las estaciones del evento.
 */
export const expectedApi = {
  set: (eventId: number, items: Array<{ stockId: number; expected: number }>) =>
    api.put<{ updated: number; skipped: number[] }>(`/xk-event/${eventId}/expected`, { items }),
};

export const merchPlannerApi = {
  // No `eventsApi.listStations`: esa lectura es a 25 y el planner necesita ver todas las estaciones.
  stationsOfEvent: (eventId: number) => api.list<XkStation>('/xk-station', { filter: { eventId }, perPage: 500 }),
};
